import React, { useRef } from "react";
import { useEffect } from "react";
import styled from "styled-components"

export const TextInput = (props: { 
    value: string,
    name: string,
    placeholderText?: string,
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
}) => {

    const input = useRef<HTMLInputElement | null>(null);
    useEffect(() => {
        input.current?.focus();
    }, []);

    return (
        <Input 
            type="text" 
            name={props.name}
            ref={input} 
            value={props.value} 
            onChange={props.onChange ?? props.onChange} 
            placeholder={props.placeholderText} />
    )
}

const Input = styled.input`
    font-size: 22px;
    font-weight: 700;
    border: 4px solid #FCAF00;
    border-radius: 8px;
    box-sizing: border-box;
    width: 100%;
    height: 60px;
    padding: 8px;
    margin-bottom: 8px;
    color: #183F48;
    background-color: #EBEBEB;

    &:focus{
        background-color: white;
        outline: none;
    }

    &::placeholder {
        color: silver;
        font-weight: 400;
        font-weight: 700;
        text-align: center;
    }
`;